import { Provider } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { DefaultErrorStateMatcher } from '@shared/validators';

export const DEFAULT_ERROR_STATE_MATCHER_PROVIDER: Provider = {
  provide: ErrorStateMatcher,
  useClass: DefaultErrorStateMatcher,
};
